import { Box, Flex, VStack, Text } from "@chakra-ui/react";
import { SquarePen, Gift, FileEdit, Rocket } from "lucide-react";

interface PromoStatsCardProps {
  stats: {
    ongoing: number;
    upcoming: number;
    drafts: number;
  };
}

export function PromoStatsCard({ stats }: PromoStatsCardProps) {
  return (
    <Box mb={4}>
      <Flex
        gap="24px"
        mb={4}
        flexWrap={{ base: "wrap", md: "nowrap" }}
        align="stretch"
      >
        {/* On-going Promos Card */}
        <Box
          w={{ base: "100%", md: "261px" }}
          h="146px"
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          p="20px"
          bgImage="/assets/img/ongoing.png"
          bgPosition="-5px center"
          bgSize="cover"
          bgRepeat="no-repeat"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          shadow="sm"
          mt={5}
        >
          <Box
            w="40px"
            h="40px"
            bg="#DC3611"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
          >
            <Rocket size={20} color="white" />
          </Box>
          <VStack align="flex-start" spacing={0} mt="auto">
            <Text fontSize="xs" color="gray.600" fontWeight="500">
              On-going Promos
            </Text>
            <Text
              fontSize="3xl"
              fontWeight="700"
              color="#0A1B39"
              lineHeight="1"
            >
              {stats.ongoing}
            </Text>
          </VStack>
        </Box>

        {/* Up Coming Promos Card */}
        <Box
          w={{ base: "100%", md: "261px" }}
          h="146px"
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          bgImage="/assets/img/upcoming.png"
          bgPosition="-5px center"
          bgSize="cover"
          bgRepeat="no-repeat"
          p="20px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          shadow="sm"
          mt={5}
        >
          <Box
            w="40px"
            h="40px"
            bg="#FFC107"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
          >
            <Gift size={20} color="white" />
          </Box>
          <VStack align="flex-start" spacing={0} mt="auto">
            <Text fontSize="xs" color="gray.600" fontWeight="500">
              Up Coming Promos
            </Text>
            <Text
              fontSize="3xl"
              fontWeight="700"
              color="#0A1B39"
              lineHeight="1"
            >
              {stats.upcoming}
            </Text>
          </VStack>
        </Box>

        {/* Saved Drafts Card */}
        <Box
          w={{ base: "100%", md: "261px" }}
          h="146px"
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="md"
          bgImage="/assets/img/saved.png"
          bgPosition="-5px center"
          bgSize="cover"
          bgRepeat="no-repeat"
          p="20px"
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          shadow="sm"
          mt={5}
        >
          <Box
            w="40px"
            h="40px"
            bg="#0EA5E9"
            borderRadius="full"
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexShrink={0}
          >
            <SquarePen size={20} color="white" />
          </Box>
          <VStack align="flex-start" spacing={0} mt="auto">
            <Text fontSize="xs" color="gray.600" fontWeight="500">
              Saved Drafts
            </Text>
            <Text
              fontSize="3xl"
              fontWeight="700"
              color="#0A1B39"
              lineHeight="1"
            >
              {stats.drafts}
            </Text>
          </VStack>
        </Box>
      </Flex>
    </Box>
  );
}

export default PromoStatsCard;
